import { useState, useEffect, useCallback } from 'react';
import { useAppContext } from '../libs/contextLib';
import { blocksModelData } from '../services/ModelService';
import { ShiftBat } from '../model/shiftBat';
import useAllStops from './useAllStops';
import useAllRoutes from './useAllRoutes';

const useBlocksAsShiftBats = () => {
  const { apiKey, operator } = useAppContext();
  const {allStops} = useAllStops();
  const {allRoutes} = useAllRoutes();
  const [shiftBats, setShiftBats] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);


  // Add a listener for real-time updates
  useEffect(() => {
    if (!apiKey || !operator || !allStops || !allRoutes) return;

    const listener = {
      id: 'blocksListener',
      loaded: (data) => {
        const transformedBlocks = Object.values(data)
          .map(block => ShiftBat.fromBlock({block, allStops, allRoutes, operator}));
        setShiftBats(transformedBlocks);
      }
    };

    blocksModelData.addListener(listener);

    return () => {
        blocksModelData.removeListener(listener.id);
    };
  }, [apiKey, operator, allStops, allRoutes]);

  return {
    shiftBats,
    isLoading,
    error
  };
};

export default useBlocksAsShiftBats; 